import React from 'react'
import Image from 'next/image'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'

import { ReactComponent as ExitIcon } from '../../../assets/icons/exit.svg'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Drawer from '@material-ui/core/Drawer'

import { useUserMenuStyles } from './user-menu.styles'
import { authUrls } from '../../../config'
import { useDisclosure, useLocale, useTranslation } from '../../../utils'
import { useQueryUser } from '../user.query'
import { useMutationLogout } from '../user.mutation'
import { SERVICES_URL } from '../../menu-service-button'
import { Link } from '@material-ui/core'

export type UserMenuItemProps = {
  title: string
  icon?: JSX.Element
  link?: string
  // props?: ListItemProps
  isBreak?: boolean
  submenu?: UserMenuItemProps[]
  secondaryContent?: React.ReactNode
  items?: Array<{ title: string; link: string }>
}

type UserMenuProps = {
  userMenu?: React.ReactNode
  onLogoutSuccess?: () => void
  redirectTo?: string
}

export const getAuthSignInUrl = (locale: string, redirectUrl?: string) => {
  return redirectUrl
    ? `${authUrls(locale).signIn}?redirectUrl=${redirectUrl}`
    : authUrls(locale).signIn
}

export const UserMenu: React.FC<UserMenuProps> = (props) => {
  const classes = useUserMenuStyles()
  const { isOpen, onClose } = useDisclosure()
  const locale = useLocale()
  const url = SERVICES_URL
  const { data: translation } = useTranslation()
  const { data: user } = useQueryUser({
    notifyOnChangeProps: ['data'],
    staleTime: 1000 * 60
  })

  const mutation = useMutationLogout({
    onSuccess: () => {
      props.onLogoutSuccess?.()
    }
  })

  const handleLogout = () => {
    mutation.mutate()
  }

  return (
    <>
      <Drawer open={isOpen} onClose={onClose} className={classes.drawer}>
        <div className={classes.headerLang}>
          <Link
            href={locale === 'ru' ? `${url.main}/ru` : `${url.main}`}
            className={classes.logoLink}
          >
            <Image
              width="75"
              height="22.06"
              alt=""
              src="/assets/logo-header.svg"
              layout="fixed"
            />
          </Link>
        </div>

        <List className={classes.menu}>
          {props.userMenu}
          {!!user && (
            <ListItem button onClick={handleLogout}>
              <ListItemIcon className={classes.iconExit}>
                <ExitIcon />
              </ListItemIcon>
              <ListItemText className={classes.exit}>
                {translation?.['menu']?.['logout'] ?? 'logout'}
              </ListItemText>
            </ListItem>
          )}
        </List>
      </Drawer>
    </>
  )
}
